import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Divider from "@mui/material/Divider";
import { Box } from "@mui/material";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";

// Generic confirm dialog (parameterized version of DeleteModal) for actions like
// disconnect/delete that need their own title/message/label.
interface Props {
  title?: string;
  message?: string;
  confirmLabel?: string;
  confirmColor?: "primary" | "error" | "warning" | "info" | "success";
  onConfirm: () => void;
  onClose: () => void;
}

function ConfirmModal({
  title = "Confirm",
  message = "Are you sure?",
  confirmLabel = "Confirm",
  confirmColor = "primary",
  onConfirm,
  onClose,
}: Props): JSX.Element {
  return (
    <Dialog maxWidth="sm" open onClose={onClose}>
      <MDBox display="flex" alignItems="center" justifyContent="space-between">
        <DialogTitle>
          <MDTypography fontSize="16px" fontWeight="medium">
            {title}
          </MDTypography>
        </DialogTitle>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </MDBox>
      <DialogContent sx={{ width: "454px" }}>
        <Box display="flex" justifyContent="center" alignContent="center">
          <MDTypography
            component="label"
            sx={{ mb: "1rem", fontWeight: "500", textAlign: "center" }}
            fontSize="14px"
            color="textSecondary"
          >
            {message}
          </MDTypography>
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <MDButton sx={{ margin: "auto" }} variant="outlined" color="primary" onClick={onClose}>
          Cancel
        </MDButton>
        <MDButton
          sx={{ margin: "auto" }}
          variant="contained"
          color={confirmColor}
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          {confirmLabel}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmModal;
